@if(present()) {
  <div class="flex w-[384px] h-min-[76px] sm:w-[632px] border-l-[4px] border-l-[#F87171]  bg-naranja bg-opacity-20 items-start justify-start sm:items-center
py-[16px] pl-[35px] pr-[20px] sm:pr-[127px] rounded-lg">
    <button (click)="closeButton()">
      <ln-close-danger-svg-icon [class]="'w-[32px] h-[32px]'"></ln-close-danger-svg-icon>
    </button>
    <span class="ml-[20px] justify-start text-cafe text-base font-semibold leading-snug">{{text}}</span>
  </div>
}

